/* eslint-disable no-underscore-dangle */
/* eslint-disable dot-notation */
/* eslint-disable no-console */
/* eslint-disable camelcase */
import { applyMiddleware, createStore, Store, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { persistStore } from 'redux-persist';
import { disconnectConsumer } from 'services/cable';
import { BiddingState } from './modules/bidding_store/types';
import persistReducers from './persistReducers';

import { ProfileState } from './modules/profile_store/types';
import { NotificationState } from './modules/notification_store/types';
import { NewNotificationState } from './modules/new_notification_store/types';
import { FlashMessagesNotificationState } from './modules/flash_message_notification_store/types';
import { PanelState } from './modules/panel_store/types';
import { MenusBehaviourState } from './modules/menus_behaviour_store/types';
import { MonitoringState } from './modules/monitoring_store/types';
import { ServicesSubscriptionState } from './modules/service_subscription_store/types';
import rootReducer from './modules/rootReducer';

import api from '../services/api';
import { ApiMiddleware } from './middlewares/apiMiddleware';
import { UserPreferencesState } from './modules/user_preferences_store/types';
import { MonitoringPreferencesState } from './modules/monitoring_preferences_store/types';
import { OnlineSearchState } from './modules/online_search_store/types';
import { FollowupState } from './modules/followup_store/types';
import { AtasState } from './modules/ata_registration_price_store/types';
import { PlansState } from './modules/plans_store/types';
import { AdditionalServicesState } from './modules/additional_services_store/types';
import { SelectedPlansState } from './modules/selected_plan_store/types';
import { SimulateState } from './modules/simulate_store/types';
import { SimulateAllState } from './modules/simulate_all_store/types';
import { UpdateSaleState } from './modules/update_sales_store/types';
import { CreateSaleState } from './modules/create_sales_store/types';
import { UserContactsState } from './modules/user_contacts_store/types';
import { ManagementState } from './modules/management_store/types';
import { ParcelamentoServicesState } from './modules/get_package_service_store/types';
import { ProportionalSaleState } from './modules/proportional_sale_simulation_store/types';
import { ImminenceState } from './modules/get_dados_imminence_store/types';
import { ContractsState } from './modules/contracts_store/types';
import { MyHistoryState } from './modules/my_history_store/types';
import { DocumentsState } from './modules/documents_store/types';
import { BulletinsState } from './modules/bulletins_store/types';
import { MyAccountState } from './modules/my_account_store/types';
import { CourseState } from './modules/course_store/types';
import { ProgressionCourseState } from './modules/progression_course_store/types';
import { FollowupOnlineSearchState } from './modules/followup_online_search_store/types';
import { MarketState } from './modules/market_store/types';
import { ConcurrentsState } from './modules/concurrents_store/types';
import { ToolsStatusState } from './modules/tools_status/types';
import { JuridicoFacilState } from './modules/juridico_facil_store/types';
import { ChatbotAssistantState } from './modules/chatbot_assistant_store/types';
import { ConsultancyLegalState } from './modules/consultancy_legal_store/types';
import { AiSummaryState } from './modules/summary_ai/types';
import { ActivitiesState } from './modules/activities_store/types';
import { BiddingChatState } from './modules/bidding_chat/types';
import { DrLicitaState } from './modules/dr_licita_store/types';
import { PortalsManagerState } from './modules/portals_manager_store/types';
import { BiddingSummaryState } from './modules/bidding_summary_store/types';
import { ConlicitasegState } from './modules/conlicitaseg_store/types';
import { RegisterState } from './modules/register_store/types';
import { ContractsAnalysisState } from './modules/contract_analysis/types';
import { CentralIaState } from './modules/central_ia/types';
import { UndoToastState } from './modules/undo_toast_store/types';
import { AcademyState } from './modules/academy_store/types';
import { AiManagementState } from './modules/ai_management_store/types';

export interface ApplicationState {
  state: any;
  session: {
    followupOnlineSearch: FollowupOnlineSearchState;
    flash_messages_notification: FlashMessagesNotificationState;
    undoToast: UndoToastState;
    new_notification: NewNotificationState;
    panel: PanelState;
    notification: NotificationState;
    menus_behaviour: MenusBehaviourState;
    onlineSearch: OnlineSearchState;
    biddings: BiddingState;
    followups: FollowupState;
    atas: AtasState;
    plans: PlansState;
    additionalServices: AdditionalServicesState;
    selectedPlan: SelectedPlansState;
    simulate: SimulateState;
    update_sale: UpdateSaleState;
    create_sale: CreateSaleState;
    management: ManagementState;
    simulate_all: SimulateAllState;
    parcelamento: ParcelamentoServicesState;
    proportional_sale: ProportionalSaleState;
    get_imminence: ImminenceState;
    contracts: ContractsState;
    my_history: MyHistoryState;
    documents: DocumentsState;
    bulletins: BulletinsState;
    my_account: MyAccountState;
    course: CourseState;
    progression_course: ProgressionCourseState;
    market: MarketState;
    concurrents: ConcurrentsState;
    tools_status: ToolsStatusState;
    juridico: JuridicoFacilState;
    chatbot_assistant: ChatbotAssistantState;
    dica_legal: ConsultancyLegalState;
    bidding_chat: BiddingChatState;
    campaign_simulation: ProportionalSaleState;
    dr_licita: DrLicitaState;
    portals_manager: PortalsManagerState;
    bidding_summary: BiddingSummaryState;
    conlicitaseg: ConlicitasegState;
    aiSummary: AiSummaryState;
    register: RegisterState;
    contract_analysis: ContractsAnalysisState;
    central_ia: CentralIaState;
    academy: AcademyState;
    ai_management: AiManagementState;
  };
  storage: {
    documents: MonitoringState;
    servicesSubscriptions: ServicesSubscriptionState;
    profile: ProfileState;
    userPreferences: UserPreferencesState;
    monitoringPreferences: MonitoringPreferencesState;
    monitoring: MonitoringState;
    userContacts: UserContactsState;
    activities: ActivitiesState;
  };
}

const middlewares = [];
const persistedVersion = localStorage.getItem('persist:boletimWeb');
let currentVersion = -1;

if (persistedVersion) {
  currentVersion = parseInt(
    JSON.parse(JSON.parse(persistedVersion || '')?._persist || '')?.version || 0,
    10,
  );
}

const EXPECTED_VERSION = parseInt(process.env.REACT_APP_STORE_VERSION || '0', 10);

const sagaMonitor =
  process.env.NODE_ENV === 'development' ? console.tron.createSagaMonitor() : null;

const sagaMiddleware = createSagaMiddleware({ sagaMonitor });

if (process.env.NODE_ENV === 'development') {
  const reactotronMiddleware = console.tron.createEnhancer();
  middlewares.push(reactotronMiddleware);
}

middlewares.push(applyMiddleware(sagaMiddleware, ApiMiddleware(api)));

const store: Store<ApplicationState> = createStore(
  persistReducers(rootReducer),
  compose(...middlewares),
);
const persistor = persistStore(store);

// store version
console.log(`Store Atual: ${currentVersion}`);
console.log(`Store Esperada: ${EXPECTED_VERSION}`);

if (currentVersion !== -1 && currentVersion !== EXPECTED_VERSION) {
  store.dispatch({ type: 'CLEAR_REDUX' });
  persistor.purge();
}

api.interceptors.response.use(
  async (response) => response,
  async (error) => {
    if (error.response?.status === 423) {
      if (store?.getState()?.storage?.profile?.profile?.isSigned) {
        disconnectConsumer();
        store.dispatch({ type: 'CLEAR_REDUX' });
      }
    }
    if (error.response?.status === 404) {
      console.error('Não encontrado!');
    }
    if (error.response?.status === 500) {
      console.error('Erro! Tente novamente!');
    }
    if (error.response?.status === 403) {
      if (error.response.data.error) {
        if (error.response.data.error === 'Recurso inativo') {
          window.location.href = '/recurso_inativo';
        }
        if (error.response.data.error === 'Assinatura vencida') {
          window.location.href = '/assinatura_vencida';
        }
        if (error.response.data.error === 'Assinatura paralisada') {
          window.location.href = '/assinatura_paralisada';
        }
        if (error.response.data.error === 'Redirecionar para tela de login') {
          window.location.href = '/';
        }
      }
    }
    return error.response;
  },
);

export { store, persistor };
